import { useAnalyticsBasePath } from '@src/hooks/useAnalyticsBasePath';
import { Navigate, useLocation } from 'react-router-dom';
import { getCanonicalAnalyticsPath } from './routes';

export function AnalyticsCanonicalRedirect() {
  const location = useLocation();
  const analyticsBasePath = useAnalyticsBasePath();
  const newPath = getCanonicalAnalyticsPath(location.pathname, analyticsBasePath);
  return <Navigate to={`${newPath}${location.search}${location.hash}`} replace />;
}
